import {
  Autocomplete as BaseAutocomplete,
  AutocompleteProps as BaseAutocompleteProps,
} from '@heroui/react';
import { cn } from '@/utils';

export type AutocompleteProps<T extends object> = Omit<BaseAutocompleteProps<T>, 'color'> & {
  color?: BaseAutocompleteProps['color'] | 'white';
};

export const Autocomplete = <T extends object>({
  color,
  popoverProps,
  clearButtonProps,
  ...baseProps
}: AutocompleteProps<T>) => {
  return (
    <BaseAutocomplete
      {...baseProps}
      clearButtonProps={{
        'aria-label': 'Clear',
        ...clearButtonProps,
      }}
      color={color === 'white' ? undefined : color}
      inputProps={
        color === 'white'
          ? { classNames: { inputWrapper: 'bg-white data-[hover=true]:bg-background' } }
          : undefined
      }
      popoverProps={{
        ...popoverProps,
        classNames: {
          ...popoverProps?.classNames,
          base: cn('!rounded-2xl', popoverProps?.classNames?.base),
          content: cn('!rounded-2xl', popoverProps?.classNames?.content),
        },
      }}
    />
  );
};

export { AutocompleteItem } from '@heroui/autocomplete';
